import { get, post, put, destroy } from "./base";

const ProductInventoryThresholdServ = {
    index: (params) => get("/product-inventory-thresholds", { params }),
    get: (id) => get(`/product-inventory-thresholds/${id}`),
    create: (data) => post("/product-inventory-thresholds", data),
    update: (id, data) => put(`/product-inventory-thresholds/${id}`, data),
    delete: (id) => destroy(`/product-inventory-thresholds/${id}`)
};

export default ProductInventoryThresholdServ;
